export interface MaderaTipo {
  id: number;
  nombre: string;
  precio: number;
}

export class PreciosExamen {
  examen: number = 55000;
  libreta: number = 15000;
  maderas: MaderaTipo[] = [
    { id: 1, nombre: '¼ in.', precio: 4000 },
    { id: 2, nombre: '½ in.', precio: 4000 },
    { id: 3, nombre: '1 in.', precio: 5000 }
  ];
  indumentaria: number = 0;

  constructor(data?: Partial<PreciosExamen>) {
    if (data) {
      Object.assign(this, data);
    }
  }

  // Calculate total for a specific selection
  static calcularTotal(
    incluyeExamen: boolean,
    incluyeLibreta: boolean, 
    maderasSeleccionadas: {tipo: MaderaTipo, cantidad: number}[],
    precioIndumentaria: number = 0,
    precios: PreciosExamen
  ): number {
    let total = 0;
    
    if (incluyeExamen) {
      total += precios.examen;
    }
    
    if (incluyeLibreta) {
      total += precios.libreta;
    }
    
    // Calculate maderas total
    for (const madera of maderasSeleccionadas) {
      total += madera.tipo.precio * madera.cantidad;
    }
    
    // Add indumentaria if provided
    if (precioIndumentaria > 0) {
      total += precioIndumentaria;
    }
    
    return total;
  }
}